import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { createIntlLocalizationProvider } from '@mews/framework/localization';
import { WithChildren } from '@optimus-web/core';
import { getLanguageCode } from '../../modules/app/selectors';
import { getLanguageChain, getTexts } from '../../modules/globalization/selectors';

const { Provider, createMessagesWithDefaults } = createIntlLocalizationProvider();
const getMessagesWithDefaults = createSelector(getTexts, getLanguageChain, createMessagesWithDefaults);

export const IntlLocalizationProvider: React.FC<WithChildren> = ({ children }) => {
    const messagesWithDefaults = useSelector(getMessagesWithDefaults);
    const languageCode = useSelector(getLanguageCode) as string;

    return (
        <Provider languageCode={languageCode} messagesWithDefaults={messagesWithDefaults}>
            {children}
        </Provider>
    );
};
